import {useEffect, useId, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {useParams} from "react-router-dom";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ThinPersonIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

interface messageInterface {
    isStudent:boolean,
    message:string,
    createdAt:string,
}

export const ParentsConsultRequestViewScreen = () => {
    const {requestId} = useParams();
    const [data,setData] = useState({
        loaded:false,
        description:'',
        createdAt:'2000-01-01 00:00:00',
        isSessionHeld:false,
        isAnswered:false,
    });
    const [messages,setMessages] = useState<messageInterface[]>([]);
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/consult/requests/view',
            {
                request:requestId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                description:string,
                createdAt:string,
                isSessionHeld:boolean,
                isAnswered:boolean,
                messages:messageInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                setData({
                   createdAt: d.createdAt,
                   description: d.description,
                   isAnswered: d.isAnswered,
                   isSessionHeld: d.isSessionHeld,
                   loaded: true,
                });
                setMessages(d.messages === null ? [] : d.messages);
            },
            () => {
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "درخواست مشاوره | نهال";
        fetchData();
    }, []);
    const newMessageId = useId();
    const [newMessage, setNewMessage] = useState('');
    const [newMessageErr, setNewMessageErr] = useState(false);
    const sendMessage = () => {
        const m = newMessage.trim();
        if(m.length < 3){
            setNewMessageErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/consult/requests/message',
            {
                request:requestId,
                message:m,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'پیام جدید ارسال گردید.',
                    'باشه',
                    5000,
                );
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'مشاوره', url: '/students/consult'},
                {title: 'مشاهده درخواست', url: `/students/consult/requests/view/${requestId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>مشاهده درخواست مشاوره</b>
                            </div>
                            <b style={{display: 'block',}}>عنوان درخواست: {data.description}</b>
                            <span style={{
                                display: 'block',
                                fontSize: 14,
                                marginTop: 5
                            }}>وضعیت جلسه مشاوره: {data.isSessionHeld ? 'برگزار شده' : 'هنوز برگزار نشده است'}</span>
                            <hr/>
                            {
                                messages.map((m, i) =>
                                    <div
                                        key={"K39fm3jsAAssA" + i}
                                        className={"row justify-content-" + (!m.isStudent ? 'end' : 'start')}>
                                        <div className="col-md-6">
                                            <div className="ticket-message">
                                                <div>
                                                    <i><ThinPersonIcon/></i>
                                                    <b>{m.isStudent ? 'شما' : 'مشاوره مدرسه'}</b>
                                                </div>
                                                <p>{m.message}</p>
                                                <span>{StringDigitsConvertToPersian(m.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(m.createdAt.split(' ')[0])).replaceAll('-', '/')}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <hr/>
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <label htmlFor={newMessageId}>پیام جدید:</label>
                                    <textarea
                                        id={newMessageId}
                                        className={"form-control" + (newMessageErr ? ' is-invalid' : '')}
                                        value={newMessage}
                                        style={{minHeight: 200, maxHeight: 500}}
                                        onChange={e => {
                                            let t = e.currentTarget.value;
                                            setNewMessage(t);
                                            setNewMessageErr(false);
                                        }}/>
                                    <div className={"invalid-feedback" + (newMessageErr ? ' d-block' : ' d-none')}>
                                        لطفا حداقل ۳ کاراکتر وارد کنید.
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{marginTop: 20}}>
                                        <button className="btn-pay" onClick={sendMessage}>
                                            <b>ارسال پیام</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};